export default __webpack_public_path__ + "static/media/img_baseCottonBunnyEars_flowers_p.fb2fe6fb.jpg";